import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Link } from "react-router-dom";
import { Avatar } from "shared/components/Avatar";
import { cx } from "shared/utils";
import { useMarkNotificationAsRead } from "../helpers/call-notification";
import { formatCalendar } from "../helpers/format-calendar";
import { Notification } from "../types";

interface SmsNotDeliveredNotificationCardProps {
  item: Notification;
}

export const SmsNotDeliveredNotificationCard = ({
  item
}: SmsNotDeliveredNotificationCardProps) => {
  const { id, read_at, url, metadata, created_at } = item;
  const markAsRead = useMarkNotificationAsRead();

  const handleClick = () => {
    if (!read_at) markAsRead([id]);
  };

  const contactName = metadata.contact_name || "A contact";
  // The generic "not delivered" would just repeat the sentence.
  const reason =
    metadata.reason_short && metadata.reason_short !== "not delivered"
      ? metadata.reason_short
      : null;

  return (
    <Link
      to={url}
      onClick={handleClick}
      className="p-6 bg-white hover:bg-alpha-40 cursor-pointer flex flex-col gap-3 w-full"
    >
      <div className="flex items-center justify-between gap-4">
        <span className="flex items-center gap-1.5 text-sm font-medium text-danger-500">
          <HugeiconsIcon icon={AlertCircleIcon} size={16} aria-hidden />
          Text not delivered
        </span>
        <p className="text-content-300 font-medium text-sm shrink-0">
          {formatCalendar(created_at)}
        </p>
      </div>
      <div className="flex items-center gap-4 min-w-0">
        <span
          className={cx(
            "size-2.5 rounded-full shrink-0",
            read_at ? "bg-alpha-40" : "bg-primary-500"
          )}
        />
        <Avatar name={contactName} size={44} className="font-bold" />
        <div className="min-w-0">
          <p className="text-lg font-bold text-content-1000 truncate">
            {contactName}
          </p>
          <p className="text-base text-content-400 truncate">
            Text to {contactName} wasn&apos;t delivered
            {reason ? `: ${reason}` : ""}
          </p>
        </div>
      </div>
    </Link>
  );
};
